var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgJupiter = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 14H16.0002V2H14.0002V14H8.4402H8.5002C10.6402 11.93 12.2802 10.17 12.2802 7.86C12.301 7.32233 12.2085 6.78629 12.0089 6.28664C11.8092 5.78698 11.5067 5.33487 11.1211 4.95962C10.7355 4.58436 10.2753 4.29434 9.77037 4.10835C9.26546 3.92237 8.7271 3.84457 8.1902 3.88C6.9147 3.87545 5.67862 4.32172 4.7002 5.14L6.0002 6.67C6.61668 6.15417 7.39639 5.87418 8.2002 5.88C8.46937 5.84441 8.74308 5.86851 9.0019 5.95058C9.26072 6.03266 9.4983 6.1707 9.69777 6.3549C9.89725 6.53911 10.0537 6.76496 10.1561 7.01644C10.2585 7.26792 10.3043 7.53885 10.2902 7.81C10.2902 9.21 9.2902 10.44 7.1402 12.49L6.3302 13.23L6.0002 13.56V14V16H14.0002V21H16.0002V16H19.0002V14Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJupiter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/jupiter.8ca424542de632a6a58e2065d4e2e4c3.svg";